import * as React from 'react';
import Grid from '../layoutComponents/Grid';

/**
 * Container for modal footer.
 */
const Footer: React.FC<{ children?: React.ReactNode }> = props => (
  <Grid
    p={3}
    justifyContent="flex-end"
    flexDirection={{
      sm: 'row'
    }}
  >
    {props.children}
  </Grid>
);

export default Footer;
